module.exports = __webpack_public_path__ + "img/mlk flagpole image 2.35ff608e.jpg";